import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import type { ReactNode } from 'react';

import { easeOut } from './motion';

interface StepTransitionProps {
  stepKey: string;
  children: ReactNode;
}

/**
 * Cross-fades signup steps. Exit is short (the system responding), enter is
 * longer (what the user watches), so a step change costs ~340ms in total.
 */
export const StepTransition = ({ stepKey, children }: StepTransitionProps) => {
  const reduceMotion = useReducedMotion();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={stepKey}
        initial={reduceMotion ? false : { opacity: 0, y: 10 }}
        animate={{
          opacity: 1,
          y: 0,
          transition: { duration: 0.22, ease: easeOut },
        }}
        exit={
          reduceMotion
            ? undefined
            : {
                opacity: 0,
                y: -6,
                transition: { duration: 0.12, ease: easeOut },
              }
        }
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};
